/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Br_History_Key_Heatingcurves1Inputs */



/**
* | output |
* | --- |
* | "Heating curves" |
*
* @param {Br_History_Key_Heatingcurves1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const br_history_key_heatingcurves1 = /** @type {((inputs?: Br_History_Key_Heatingcurves1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Br_History_Key_Heatingcurves1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Heating curves")
	return /** @type {LocalizedString} */ ("Courbes de chauffage")
});
export { br_history_key_heatingcurves1 as "br_history_key_heatingCurves" }